import theme from '../../../lib/theme';
import { MembershipChallengeProps } from './MembershipChallenge';

const {
  layouts,
  corners,
  scale,
  colors,
  media,
  font: {
    families,
    heights,

    ...font
  },
} = theme;

export default ({
  mode = 'full',
}: MembershipChallengeProps) => ({

  container: {
    ...layouts.column,
		justifyContent: 'center',
    display: 'flex',
		backgroundColor: 'rgba(101, 31, 255, 0.1)',
		padding: mode === 'full' ? '20px' : '10px',
    gap: mode === 'full' ? scale.xs : scale.xxxs,
	},
	title: {
		display: 'block',
		fontSize: mode === 'full' ? '20px !important' : '16px !important',
		margin: '0 !important',
		lineHeight: 'unset !important',

    '& > a': {
      color: colors.black,
      textDecoration: 'underline',

      '&:hover': {
        color: colors.sas.primary,
      }
    },
  },
	subtitle: {

	},
  form: {
    '> .form-row': {
      [media.m.down]: {
        display: 'flex',
        gap: mode === 'full' ? scale.xxxs : scale.xxxxs,
      },  
    }
  },
  submitButton: {
    padding: mode === 'full' ? `${scale.xs} ${scale.m}!important` : `${scale.xxxs} ${scale.xs}!important`,
  }
});
